import { render, staticRenderFns } from "./FormLayouts.vue?vue&type=template&id=09472436&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09472436')) {
      api.createRecord('09472436', component.options)
    } else {
      api.reload('09472436', component.options)
    }
    module.hot.accept("./FormLayouts.vue?vue&type=template&id=09472436&", function () {
      api.rerender('09472436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/forms/FormLayouts.vue"
export default component.exports